import { Component, Input } from '@angular/core';

import { Registration, ToolRegistration } from '../../models/registration';

@Component({
    selector: 'app-tool-details',
    imports: [],
    templateUrl: './tool-details.component.html',
    styleUrl: './tool-details.component.scss'
})
export class ToolDetailsComponent {
  @Input() toolRegistrations!: ToolRegistration[];
  @Input() currentPhaseCode!: string;

  constructor() {
    this.toolRegistrations = this.toolRegistrations?.filter(x => x.phaseCode == this.currentPhaseCode)
  }
}



//  @Input() workerRegistrations!: WorkerRegistration[];
// @Input() currentPhaseCode!: string;
